(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8557],{

/***/ 88557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_CustomerReviewModal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(147568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(414924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(629815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(197582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./node_modules/react-rating-stars-component/dist/react-stars.js
var react_stars = __webpack_require__(511312);
// EXTERNAL MODULE: ./src/components/CustomerReviewModal/index.module.scss
var index_module = __webpack_require__(869226);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./src/redux/actions/catalog.js
var catalog = __webpack_require__(96031);
// EXTERNAL MODULE: ./src/components/Common/Toast/index.jsx
var Toast = __webpack_require__(40804);
;// CONCATENATED MODULE: ./src/utils/publishReviewToastNotificationText.js
function publishReviewToastNotificationText(autoPublishFlag) {
    return autoPublishFlag ? "Thank you for submitting review." : "Thank you for submitting review. It is currently under process.";
}

// EXTERNAL MODULE: ./src/utils/compressedImagesHelpers.ts
var compressedImagesHelpers = __webpack_require__(940619);
// EXTERNAL MODULE: ./src/components/BasicModal/index.tsx
var BasicModal = __webpack_require__(475868);
// EXTERNAL MODULE: ./src/utils/getThemeColor.js
var getThemeColor = __webpack_require__(270758);
// EXTERNAL MODULE: ./src/assets/svgExports/PlusIcon.js
var PlusIcon = __webpack_require__(408886);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/Close.js
var Close = __webpack_require__(695537);
// EXTERNAL MODULE: ./src/components/ReviewsSection/constants.js
var constants = __webpack_require__(601829);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/WIdgetPropertiesBasic/components/Button/index.tsx + 1 modules
var Button = __webpack_require__(846976);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/AddAPhotoOutlined.js
var AddAPhotoOutlined = __webpack_require__(637801);
// EXTERNAL MODULE: ./src/utils/getAuthToken.js
var getAuthToken = __webpack_require__(861305);
// EXTERNAL MODULE: ./src/utils/checkClientDeviceType.js
var checkClientDeviceType = __webpack_require__(313508);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(693967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./src/components/CustomerReviewModal/UploadProgress.tsx


var UPLOAD_COMPLETE = 100;
function UploadProgress(param) {
    var inProgress = param.inProgress;
    var ref = (0,react.useState)(0), progress = ref[0], setProgress = ref[1];
    (0,react.useEffect)(function() {
        if (inProgress) setProgress(0);
        var id = setInterval(function() {
            setProgress(function(prev) {
                var next = prev + (UPLOAD_COMPLETE - prev) / 50;
                return next >= UPLOAD_COMPLETE ? UPLOAD_COMPLETE : next;
            });
        }, 100);
        return function() {
            return clearInterval(id);
        };
    }, [
        inProgress
    ]);
    (0,react.useEffect)(function() {
        if (!inProgress) setProgress(UPLOAD_COMPLETE);
    }, [
        inProgress
    ]);
    return inProgress && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "tw-relative tw-flex tw-h-[72px] tw-w-[72px] tw-items-center tw-justify-center tw-rounded-[4px] tw-bg-[#C4C4C4]",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tw-h-[24px] tw-w-[24px] tw-rounded-full tw-border-[2px] tw-border-solid tw-border-white tw-duration-300",
            style: {
                background: "conic-gradient(white 0% ".concat(progress, "%, transparent ").concat(progress, "% 100%)")
            }
        })
    });
}

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(409669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./src/config/endpoints.js
var endpoints = __webpack_require__(951919);
;// CONCATENATED MODULE: ./src/utils/uploadCustomerMediaToS3.js





var uploadCustomerMediaToS3 = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var payload, authToken, callback, type, ref, forVideo, config, response, ref1, imageURL, ref2, ref3, error, ref4, ref5, errorMessage;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    payload = param.payload, authToken = param.authToken, callback = param.callback, type = param.type;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    forVideo = type === "video";
                    config = {
                        headers: {
                            auth_token: authToken,
                            app_os: "cfe",
                            app_version: "0.1.0",
                            "Content-Type": !forVideo ? "application/json" : "multipart/form-data"
                        }
                    };
                    return [
                        4,
                        axios_default().post(endpoints/* ENDPOINT.LOGS.UPLOAD_CUSTOMER_MEDIA_TO_S3 */.f.LOGS.UPLOAD_CUSTOMER_MEDIA_TO_S3, payload, config)
                    ];
                case 2:
                    response = _state.sent();
                    if (response && (response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.status)) {
                        ;
                        imageURL = JSON.parse(response === null || response === void 0 ? void 0 : (ref1 = response.data) === null || ref1 === void 0 ? void 0 : ref1.data);
                        callback && callback(imageURL);
                        return [
                            2,
                            imageURL
                        ];
                    } else {
                        ;
                        (0,Toast/* toastNotifyError */.Lu)((response === null || response === void 0 ? void 0 : (ref2 = response.data) === null || ref2 === void 0 ? void 0 : ref2.message) || "Something went wrong!");
                        callback && callback({
                            error: true
                        });
                        return [
                            2,
                            {
                                error: true,
                                errorMessage: (response === null || response === void 0 ? void 0 : (ref3 = response.data) === null || ref3 === void 0 ? void 0 : ref3.message) || ""
                            }
                        ];
                    }
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    errorMessage = (error === null || error === void 0 ? void 0 : (ref4 = error.response) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.data) === null || ref5 === void 0 ? void 0 : ref5.message) || "";
                    callback && callback({
                        error: true,
                        errorMessage: errorMessage
                    });
                    return [
                        2,
                        {
                            error: true,
                            errorMessage: errorMessage
                        }
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function uploadCustomerMediaToS3(_) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/PlayCircleOutlineRounded.js
var PlayCircleOutlineRounded = __webpack_require__(223151);
;// CONCATENATED MODULE: ./src/components/CustomerReviewModal/MediaWithRetry.tsx




var MediaWithRetry = function(param) {
    var media = param.media, _className = param.className, className = _className === void 0 ? "" : _className, _retryCount = param.retryCount, retryCount = _retryCount === void 0 ? 3 : _retryCount, _retryDelay = param.retryDelay, retryDelay = _retryDelay === void 0 ? 1000 : _retryDelay;
    var ref = (0,react.useState)(media === null || media === void 0 ? void 0 : media.media_url), src = ref[0], setSrc = ref[1];
    var ref1 = (0,react.useState)(0), attempt = ref1[0], setAttempt = ref1[1];
    var ref2 = (0,react.useState)(false), hasError = ref2[0], setHasError = ref2[1];
    // Retry on failure
    (0,react.useEffect)(function() {
        if (hasError && attempt <= retryCount) {
            var newSrc = "".concat((media === null || media === void 0 ? void 0 : media.temp_media_url) || (media === null || media === void 0 ? void 0 : media.media_url), "?retry=").concat(Date.now());
            setSrc(newSrc);
        }
    }, [
        attempt,
        media === null || media === void 0 ? void 0 : media.media_url,
        hasError
    ]);
    var handleError = function() {
        if (attempt < retryCount) {
            setTimeout(function() {
                return setAttempt(function(prev) {
                    return prev + 1;
                });
            }, retryDelay);
        } else {
            setHasError(true);
        }
    };
    return hasError ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "tw-text-center tw-text-sm tw-text-gray-400",
        children: "Failed to load media"
    }) : (media === null || media === void 0 ? void 0 : media.media_type) !== constants/* REVIEW_MEDIA_TYPE.IMAGE */.x.IMAGE ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                src: src,
                onError: handleError,
                className: "tw-max-h-full tw-max-w-full ".concat(className)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "tw-absolute tw-left-1/2 tw-top-1/2 tw-flex -tw-translate-x-1/2 -tw-translate-y-1/2 tw-text-white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayCircleOutlineRounded["default"], {})
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        src: src,
        alt: "media",
        onError: handleError,
        className: "tw-max-h-full tw-max-w-full ".concat(className)
    });
};
/* harmony default export */ var CustomerReviewModal_MediaWithRetry = (MediaWithRetry);

// EXTERNAL MODULE: ./src/utils/constants/index.js
var utils_constants = __webpack_require__(913886);
;// CONCATENATED MODULE: ./src/components/CustomerReviewModal/index.js





























var MEDIA_LIMIT = 3;
var CustomerReviewModal = function(param) {
    var product = param.product, open = param.open, onClose = param.onClose, loggedInUserReview = param.loggedInUserReview, onSubmit = param.onSubmit, order_id = param.order_id, _ratingFromProps = param.ratingFromProps, ratingFromProps = _ratingFromProps === void 0 ? null : _ratingFromProps;
    var handleRatingChange = function handleRatingChange(rating) {
        setReviewState(function(prevState) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                rating: rating
            });
        });
    };
    var addImage = function addImage() {
        var ref;
        mediaInputRef === null || mediaInputRef === void 0 ? void 0 : (ref = mediaInputRef.current) === null || ref === void 0 ? void 0 : ref.click();
    };
    var removeMediaImage = function removeMediaImage(index) {
        var ref;
        setReviewState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, reviewState), {
            mediaList: reviewState === null || reviewState === void 0 ? void 0 : (ref = reviewState.mediaList) === null || ref === void 0 ? void 0 : ref.filter(function(media, currIndex) {
                return currIndex !== index;
            })
        }));
    };
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var themeColor = (0,getThemeColor/* getThemeColor */.p)() || "#000000";
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref7 = (0,es/* useSelector */.v9)(function(state) {
        return {
            storeInfo: state.storeReducer.store,
            userData: state.userReducer.data,
            reviewSettings: state.catalogReducer.reviewSettings
        };
    }), storeInfo = ref7.storeInfo, userData = ref7.userData, reviewSettings = ref7.reviewSettings;
    var ref8 = (0,react.useState)({
        full_name: (loggedInUserReview === null || loggedInUserReview === void 0 ? void 0 : loggedInUserReview.full_name) || "",
        review: (loggedInUserReview === null || loggedInUserReview === void 0 ? void 0 : loggedInUserReview.review) || "",
        rating: ratingFromProps || (loggedInUserReview === null || loggedInUserReview === void 0 ? void 0 : loggedInUserReview.rating) || 0,
        mediaList: (loggedInUserReview === null || loggedInUserReview === void 0 ? void 0 : loggedInUserReview.store_item_review_media) || []
    }), reviewState = ref8[0], setReviewState = ref8[1];
    var ref9 = (0,react.useState)(false), isUploading = ref9[0], setIsUplading = ref9[1];
    var mediaInputRef = (0,react.useRef)(null);
    var imageUrl = (product === null || product === void 0 ? void 0 : product.thumbnail_url) || (product === null || product === void 0 ? void 0 : product.image_url);
    var compressedImages = product === null || product === void 0 ? void 0 : (ref = product.images) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.compressed_images;
    var mediaLimitReached = (reviewState === null || reviewState === void 0 ? void 0 : (ref2 = reviewState.mediaList) === null || ref2 === void 0 ? void 0 : ref2.length) === MEDIA_LIMIT;
    var isLastMediaUpoading = (reviewState === null || reviewState === void 0 ? void 0 : (ref3 = reviewState.mediaList) === null || ref3 === void 0 ? void 0 : ref3.length) === MEDIA_LIMIT - 1 && isUploading;
    var disableSubmitBtn = (0,react.useMemo)(function() {
        return !reviewState.review || !reviewState.full_name || !reviewState.rating;
    }, [
        reviewState
    ]);
    //   useEffect(() => {
    //   if (loggedInUserReview && !orderStatusPage) {
    //     setReviewState({
    //       full_name: loggedInUserReview?.full_name,
    //       review: loggedInUserReview?.review,
    //       rating: loggedInUserReview?.rating,
    //       mediaList: loggedInUserReview?.store_item_review_media,
    //     });
    //   }
    // }, [loggedInUserReview, orderStatusPage]);
    (0,react.useEffect)(function() {
        if (open) {
            setReviewState({
                full_name: (loggedInUserReview === null || loggedInUserReview === void 0 ? void 0 : loggedInUserReview.full_name) || "",
                review: (loggedInUserReview === null || loggedInUserReview === void 0 ? void 0 : loggedInUserReview.review) || "",
                rating: ratingFromProps || (loggedInUserReview === null || loggedInUserReview === void 0 ? void 0 : loggedInUserReview.rating) || 0,
                mediaList: (loggedInUserReview === null || loggedInUserReview === void 0 ? void 0 : loggedInUserReview.store_item_review_media) || []
            });
        }
    }, [
        open,
        ratingFromProps
    ]);
    var handleChange = function(e) {
        var inputValue = e.target.value;
        var inputFieldName = e.target.name;
        if (inputFieldName === "full_name" && !utils_constants/* CHARS_OR_SPACE_REGEX.test */.P.test(inputValue)) {
            return;
        }
        if (inputValue && inputValue.trim() || inputValue.length === 0) {
            var maxLength = 1500;
            setReviewState(function(prevState) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), (0,_define_property/* default */.Z)({}, inputFieldName, inputValue.slice(0, maxLength)));
            });
        }
    };
    var handleFileChange = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
            var ref, ref1, ref2, input, file, fileSizeInMB, isMediaTypeImage, formData, mediaUrl;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        input = event.target;
                        file = (ref = input.files) === null || ref === void 0 ? void 0 : ref[0];
                        if (!file) return [
                            2
                        ];
                        fileSizeInMB = file.size / (1024 * 1024);
                        if (fileSizeInMB >= 5) {
                            (0,Toast/* toastNotifyError */.Lu)("File size should be less than 5MB");
                            setIsUplading(false);
                            return [
                                2
                            ];
                        }
                        isMediaTypeImage = file === null || file === void 0 ? void 0 : (ref1 = file.type) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.startsWith) === null || ref2 === void 0 ? void 0 : ref2.call(ref1, "image/");
                        formData = new FormData();
                        formData.append("media_type", "review_rating");
                        formData.append("media", file);
                        formData.append("store_id", storeInfo.store_id);
                        return [
                            4,
                            uploadCustomerMediaToS3({
                                payload: formData,
                                authToken: (0,getAuthToken/* getAuthToken */.b)(),
                                type: !isMediaTypeImage ? "video" : "image"
                            })
                        ];
                    case 1:
                        mediaUrl = _state.sent();
                        if (!(mediaUrl === null || mediaUrl === void 0 ? void 0 : mediaUrl.error)) {
                            setReviewState((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, reviewState), {
                                mediaList: (0,_to_consumable_array/* default */.Z)(reviewState.mediaList || []).concat([
                                    {
                                        media_id: 0,
                                        media_url: mediaUrl,
                                        temp_media_url: URL.createObjectURL(file),
                                        media_type: isMediaTypeImage ? constants/* REVIEW_MEDIA_TYPE.IMAGE */.x.IMAGE : constants/* REVIEW_MEDIA_TYPE.VIDEO */.x.VIDEO
                                    }
                                ])
                            }));
                        } else {
                            (0,Toast/* toastNotifyError */.Lu)("something went wrong!");
                        }
                        // Reset input so selecting the same file again triggers onChange
                        input.value = "";
                        setIsUplading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleFileChange(event) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSubmit = function() {
        if (disableSubmitBtn) {
            (0,Toast/* toastNotifyError */.Lu)("Pease fill all the mendatory fields !");
            return;
        }
        var payload = {
            store_id: storeInfo.store_id,
            order_id: order_id,
            review_rating: [
                {
                    status: reviewSettings.auto_publish ? constants/* REVIEW_RATING_STATUS.PUBLISHED */.u.PUBLISHED : constants/* REVIEW_RATING_STATUS.NEW */.u.NEW,
                    id: loggedInUserReview ? loggedInUserReview === null || loggedInUserReview === void 0 ? void 0 : loggedInUserReview.id : 0,
                    item_id: (product === null || product === void 0 ? void 0 : product.id) || (product === null || product === void 0 ? void 0 : product.item_id),
                    full_name: reviewState.full_name,
                    review: reviewState.review,
                    reply: loggedInUserReview ? loggedInUserReview === null || loggedInUserReview === void 0 ? void 0 : loggedInUserReview.reply : "",
                    review_seen: false,
                    phone: userData.phone,
                    rating: reviewState.rating,
                    store_item_review_media: reviewState.mediaList
                }, 
            ]
        };
        dispatch((0,catalog/* publishReview */.zU)(payload, function() {
            (0,Toast/* toastNotifySuccess */.jh)(publishReviewToastNotificationText(reviewSettings.auto_publish));
            onSubmit && onSubmit();
        }));
        onClose();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BasicModal/* default */.Z, {
        show: open,
        onClose: onClose,
        headingClasses: "!tw-p-0 !tw-overflow-visible !tw-border-none",
        customClasses: "md:!tw-min-w-[740px] !tw-rounded-[8px_8px_0px_0px] md:!tw-rounded-[8px] !tw-m-0 !tw-overflow-scroll",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                ref: mediaInputRef,
                type: "file",
                accept: "image/*,video/*",
                className: "tw-hidden",
                onChange: function(e) {
                    var ref, ref1;
                    if (!(e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : (ref1 = ref.files) === null || ref1 === void 0 ? void 0 : ref1.length)) return;
                    setIsUplading(true);
                    handleFileChange(e);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-relative tw-h-full tw-px-[32px] tw-pb-[142px] tw-pt-[36px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center mb28px tw-gap-[20px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "border-grey1 tw-relative tw-flex tw-h-[80px] tw-w-[80px] tw-flex-shrink-0 tw-cursor-pointer tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-[4px] tw-border-[1px] tw-border-solid tw-bg-contain",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: (0,compressedImagesHelpers/* getImageUrlFromCompressedImages */.vb)(compressedImages, imageUrl, {
                                        maxImgSize: compressedImagesHelpers/* imgSizeEnums.LOW */.Hp.LOW
                                    }),
                                    width: "64px",
                                    height: "64px"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-column tw-gap-[16px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mv0 tw-line-clamp-1 tw-text-[18px]/[18px] tw-font-medium tw-text-black",
                                        children: (product === null || product === void 0 ? void 0 : product.name) || (product === null || product === void 0 ? void 0 : product.item_name)
                                    }),
                                    ((loggedInUserReview === null || loggedInUserReview === void 0 ? void 0 : loggedInUserReview.rating) && !(loggedInUserReview === null || loggedInUserReview === void 0 ? void 0 : loggedInUserReview.review) || !checkClientDeviceType/* IS_MOBILE */.q$) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex items-center",
                                        children: [
                                            !checkClientDeviceType/* IS_MOBILE */.q$ && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_stars/* default */.Z, {
                                                size: 32,
                                                classNames: (index_module_default()).gap,
                                                onChange: handleRatingChange,
                                                value: reviewState.rating,
                                                count: 5
                                            }, "stars_".concat(reviewState.rating)),
                                            (loggedInUserReview === null || loggedInUserReview === void 0 ? void 0 : loggedInUserReview.rating) && !(loggedInUserReview === null || loggedInUserReview === void 0 ? void 0 : loggedInUserReview.review) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "ml12px mv0 bg-lime-green-color pv4px ph8px f12px fw5 white-color br2 ",
                                                children: "Submitted"
                                            }) : null
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    checkClientDeviceType/* IS_MOBILE */.q$ && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-mb-[32px] tw-flex tw-flex-col tw-gap-[12px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mv0 tw-text-[16px]/[18px] tw-font-normal tw-text-black",
                                children: "Your Rating"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_stars/* default */.Z, {
                                size: 32,
                                classNames: classnames_default()((index_module_default()).gap, "tw-flex tw-gap-[2px]"),
                                onChange: handleRatingChange,
                                value: reviewState.rating,
                                count: 5
                            }, "stars_".concat(reviewState.rating))
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-flex tw-flex-col tw-gap-[32px]",
                        children: [
                            !!(reviewSettings === null || reviewSettings === void 0 ? void 0 : reviewSettings.media_upload_enabled) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "tw-flex",
                                children: !!(reviewState === null || reviewState === void 0 ? void 0 : (ref4 = reviewState.mediaList) === null || ref4 === void 0 ? void 0 : ref4.length) || isUploading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "tw-flex tw-gap-[16px]",
                                    children: [
                                        reviewState === null || reviewState === void 0 ? void 0 : (ref5 = reviewState.mediaList) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.map) === null || ref6 === void 0 ? void 0 : ref6.call(ref5, function(media, index) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                                className: "border-grey1 tw-relative tw-flex tw-h-[72px] tw-w-[72px] tw-items-center tw-justify-center tw-rounded-[4px] tw-object-contain",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                                                        fontSize: "small",
                                                        className: "border-grey1 tw-absolute tw-right-0 tw-top-0 -tw-translate-y-1/2 tw-translate-x-1/2 tw-cursor-pointer tw-rounded-full tw-bg-white",
                                                        onClick: function() {
                                                            return removeMediaImage(index);
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomerReviewModal_MediaWithRetry, {
                                                        media: media
                                                    })
                                                ]
                                            }, (media === null || media === void 0 ? void 0 : media.temp_media_url) || (media === null || media === void 0 ? void 0 : media.media_url));
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadProgress, {
                                            inProgress: isUploading
                                        }),
                                        !mediaLimitReached && !isLastMediaUpoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "tw-flex tw-h-[72px] tw-w-[72px] tw-items-center tw-justify-center tw-rounded-[4px] tw-border tw-border-dashed",
                                            style: {
                                                color: themeColor,
                                                borderColor: themeColor,
                                                backgroundColor: themeColor + "0D"
                                            },
                                            onClick: addImage,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlusIcon/* PlusIcon */.p, {
                                                iconColor: themeColor
                                            })
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "tw-flex tw-h-[48px] tw-w-full tw-cursor-pointer tw-items-center tw-justify-center tw-gap-[12px] tw-rounded-[4px] tw-border tw-border-dashed",
                                    style: {
                                        color: themeColor,
                                        borderColor: themeColor,
                                        backgroundColor: themeColor + "0D"
                                    },
                                    onClick: addImage,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AddAPhotoOutlined["default"], {
                                            sx: {
                                                transform: "scaleX(-1)"
                                            },
                                            className: "tw-mb-[4px] !tw-h-[20px] !tw-w-[20px]",
                                            color: "inherit"
                                        }),
                                        "Share a video or photo"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-column tw-gap-[12px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mv0 tw-text-[16px]/[18px] tw-font-normal tw-text-black",
                                        children: "Full Name"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        name: "full_name",
                                        value: reviewState.full_name,
                                        onChange: handleChange,
                                        placeholder: "Enter your name",
                                        className: "border-grey1 tw-rounded-lg tw-p-[16px] tw-text-sm tw-font-normal placeholder:tw-text-[#707070]"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-column tw-gap-[12px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mv0 tw-text-[16px]/[18px] tw-font-normal tw-text-black",
                                        children: "Product Review"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                                        name: "review",
                                        value: reviewState.review,
                                        onChange: handleChange,
                                        placeholder: "What should other customers know?",
                                        className: "border-grey1 tw-h-[100px] tw-resize-none tw-rounded-lg tw-p-[16px] tw-text-sm tw-font-normal placeholder:tw-text-[#707070]"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-fixed tw-bottom-0 tw-mt-[30px] tw-flex tw-w-full tw-justify-end tw-gap-[16px] tw-border tw-border-t tw-border-solid tw-border-gray-200 tw-bg-white tw-px-[32px] tw-py-[36px] md:tw-absolute md:tw-border-none",
                children: [
                    !checkClientDeviceType/* IS_MOBILE */.q$ && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: onClose,
                        variant: "tertiary",
                        color: "#000000",
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        variant: "primary",
                        disabled: disableSubmitBtn,
                        className: classnames_default()((index_module_default()).submitBtn, "!tw-h-[46px]", checkClientDeviceType/* IS_MOBILE */.q$ ? "!tw-w-full" : ""),
                        onClick: handleSubmit,
                        backgroundColor: disableSubmitBtn ? themeColor + "66" : themeColor,
                        color: "#FFFFFF",
                        children: checkClientDeviceType/* IS_MOBILE */.q$ ? "Submit Review" : "Submit"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_CustomerReviewModal = (CustomerReviewModal);


/***/ }),

/***/ 601829:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ REVIEW_RATING_STATUS; },
/* harmony export */   "x": function() { return /* binding */ REVIEW_MEDIA_TYPE; }
/* harmony export */ });
var REVIEW_MEDIA_TYPE = {
    IMAGE: 1,
    VIDEO: 2
};
var REVIEW_RATING_STATUS = {
    NEW: 2,
    PUBLISHED: 1,
    UNPUBLISHED: 0
};


/***/ }),

/***/ 940619:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hp": function() { return /* binding */ imgSizeEnums; },
/* harmony export */   "N7": function() { return /* binding */ getMaxImgSizeForComponent; },
/* harmony export */   "VW": function() { return /* binding */ getSrcSetFromCompressedImages; },
/* harmony export */   "Xx": function() { return /* binding */ componentTypeEnums; },
/* harmony export */   "vb": function() { return /* binding */ getImageUrlFromCompressedImages; }
/* harmony export */ });
var componentTypeEnums = {
    CARD: 1,
    ITEM_THUMBNAIL: 2
};
var imgSizeEnums = {
    LOW: 1,
    MID: 2,
    HIGH: 3
};
// the srcset is creating a few problems where device pixel ratio is high (loading a lower resolution image)
// consider using getImageUrlFromCompressedImages for any such cases
function getSrcSetFromCompressedImages() {
    var compressedImages = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, mainImage = arguments.length > 1 ? arguments[1] : void 0, extraFields = arguments.length > 2 ? arguments[2] : void 0;
    var parsedCompressedImages = parseCompressedImageObj(compressedImages || {});
    return prepareSrcSet(parsedCompressedImages, mainImage, (extraFields === null || extraFields === void 0 ? void 0 : extraFields.maxImgSize) || imgSizeEnums.HIGH, (extraFields === null || extraFields === void 0 ? void 0 : extraFields.minImgSize) || imgSizeEnums.LOW);
}
function getImageUrlFromCompressedImages() {
    var compressedImages = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, mainImage = arguments.length > 1 ? arguments[1] : void 0, extraFields = arguments.length > 2 ? arguments[2] : void 0;
    var parsedCompressedImages = parseCompressedImageObj(compressedImages || {});
    var screenWidth =  false ? 0 : window.innerWidth;
    var maxImgSize = (extraFields === null || extraFields === void 0 ? void 0 : extraFields.maxImgSize) || imgSizeEnums.HIGH;
    var urlToReturn = mainImage;
    if (parsedCompressedImages[imgSizeEnums.LOW] && (screenWidth <= 320 || maxImgSize === imgSizeEnums.LOW)) {
        urlToReturn = parsedCompressedImages[imgSizeEnums.LOW];
    } else if (parsedCompressedImages[imgSizeEnums.MID] && (screenWidth > 320 && screenWidth < 768 || maxImgSize === imgSizeEnums.MID)) {
        urlToReturn = parsedCompressedImages[imgSizeEnums.MID];
    } else if (parsedCompressedImages[imgSizeEnums.HIGH]) {
        urlToReturn = parsedCompressedImages[imgSizeEnums.HIGH];
    }
    return urlToReturn;
}
function prepareSrcSet() {
    var imgObj = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, mainImage = arguments.length > 1 ? arguments[1] : void 0, maxImgSize = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : imgSizeEnums.HIGH, minImgSize = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : imgSizeEnums.LOW;
    var resString = "";
    var dpr =  false ? 0 : window.devicePixelRatio;
    if (minImgSize <= imgSizeEnums.LOW && maxImgSize >= imgSizeEnums.LOW && imgObj[imgSizeEnums.LOW]) {
        resString += "".concat(imgObj[imgSizeEnums.LOW], " ").concat(320 * dpr, "w, ");
    }
    if (minImgSize <= imgSizeEnums.MID && maxImgSize >= imgSizeEnums.MID && imgObj[imgSizeEnums.MID]) {
        resString += "".concat(imgObj[imgSizeEnums.MID], " ").concat(480 * dpr, "w, ");
    }
    if (minImgSize <= imgSizeEnums.HIGH && maxImgSize >= imgSizeEnums.HIGH && imgObj[imgSizeEnums.HIGH]) {
        resString += "".concat(imgObj[imgSizeEnums.HIGH], " ").concat(768 * dpr, "w, ");
    }
    if (!maxImgSize || !resString) {
        resString += "".concat(mainImage);
    }
    return resString;
}
// returns Object with image urls corresponding to low medium and high which is Represented by 1,2,3
function parseCompressedImageObj() {
    var compressedImages = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var res = {};
    var keys = Object.keys(compressedImages) // keys are strings where numbers are separated by *. Eg. "200*200"
    ;
    // sorting keys (eg. key=200*200) to handle the case when we get jumbled order of image sizes.
    keys.sort(function(a, b) {
        var first = parseInt(a.split("*")[0]);
        var second = parseInt(b.split("*")[0]);
        return first - second;
    });
    if (keys.length >= 1) {
        res[imgSizeEnums.LOW] = compressedImages[keys[0]];
    }
    if (keys.length >= 2) {
        res[imgSizeEnums.MID] = compressedImages[keys[1]];
    }
    if (keys.length >= 3) {
        res[imgSizeEnums.HIGH] = compressedImages[keys[2]];
    }
    return res;
}
function getMaxImgSizeForComponent(componentType) {
    if (componentType === componentTypeEnums.CARD) {
        return imgSizeEnums.MID;
    } else if (componentType === componentTypeEnums.ITEM_THUMBNAIL) {
        return imgSizeEnums.LOW;
    }
    return imgSizeEnums.MID;
}


/***/ }),

/***/ 869226:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modal":"CustomerReviewModal_modal__KYzk8","gap":"CustomerReviewModal_gap__xeXG_","crossIcon":"CustomerReviewModal_crossIcon__W4th3","btnContainer":"CustomerReviewModal_btnContainer__0ITTN","cancelBtn":"CustomerReviewModal_cancelBtn__6J7Hi","submitBtn":"CustomerReviewModal_submitBtn__n4GQY","mobileModal":"CustomerReviewModal_mobileModal__P35iH","header":"CustomerReviewModal_header__LPSb_"};

/***/ })

}]);